import { osmAuth } from './osm-auth.mjs';
globalThis.osmAuth = osmAuth;
